import type { CreateSuggestionRequest } from 'api/__GENERATED';
import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toSuggestion } from './transformers/toSuggestion';

// Sends a create-suggestion request to Suggestion_CreateSuggestion and returns
// the server-assigned Data.Suggestion. improvementAreaId rides through when the
// caller has stamped one (the mock-create saga preselects the lowest-sortOrder
// area). API treats the field as optional — null is omitted from the body.
async function createSuggestion(args: {
  tenantId: string;
  suggestion: Data.Suggestion;
}) {
  const { tenantId, suggestion } = args;

  const body: CreateSuggestionRequest = {
    title: suggestion.name,
    problemStatement: suggestion.problemStatement,
    solutionProposal: suggestion.solutionProposal,
    createdBy: suggestion.reporter,
    ...(suggestion.improvementAreaId !== null && {
      improvementAreaId: suggestion.improvementAreaId,
    }),
  };

  const apiCall = apiClient.Suggestion_CreateSuggestion(body, {
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to create suggestion',
    },
    onSuccess: (dto) => {
      const createdSuggestion = toSuggestion(dto);
      return { suggestion: createdSuggestion };
    },
  });
}

export { createSuggestion };
